import styled from "styled-components";

export const StyledVerbalizeNowIcon = styled.span`
  cursor: pointer;
  display: flex;
  flex-direction: flex-end;
  background-color: #1a1033;
  width: 65px;
  height: 65px;
  border-radius: 50%;

  img {
    width: 65px;

    @media screen and (max-width: 479px) {
      width: 60px;
    }

    object-fit: cover;
  }
`;
